import { CRTMSG, DELMSG, UPTMSG } from 'src/Helper/toastmsg';
import {
  LEDGER_CREATE, LEDGER_LIST, LEDGER_SINGLE, LEDGER_UPDATE, LEDGER_DELETE, CLEAR_LEDGER_TEMP_STATES, CLEAR_LEDGER_STATES
} from '../../../Helper/actionsTypes';

const ledgerReducer = (state = [], action) => {
  const { code, message, results } = action.payload || ''
  switch (action.type) {
    case LEDGER_LIST: {
      return code === 200
        ? { ...state, list: results }
        : { ...state, list: [] };
    }
    case LEDGER_SINGLE: {
      return code === 200
        ? { ...state, single: results[0]}
        : { ...state, single: '' }
    }
    case LEDGER_DELETE: {
      return code === 200 ? { ...state, itemDeleted: true, message }
        : code === 404 ? { ...state, badReq: true, message }
          : code === 500 ? { ...state, itemDeleted: false, message: DELMSG }
            : { ...state, itemDeleted: false, message }
    }
    case LEDGER_CREATE: {
      return code === 200 ? { ...state, itemSaved: true, message }
        : code === 404 ? { ...state, badReq: true, message }
          : code === 500 ? { ...state, itemSaved: false, message: CRTMSG }
            : { ...state, itemSaved: false, message }
    }
    case LEDGER_UPDATE: {
      return code === 200 ? { ...state, itemUpdated: true, message }
        : code === 404 ? { ...state, badReq: true, message }
          : code === 500 ? { ...state, itemUpdated: false, message: UPTMSG }
            : { ...state, itemUpdated: false, message }
    }
    case CLEAR_LEDGER_TEMP_STATES: return { ...state, itemDeleted: null, itemSaved: null, itemUpdated: null, delete: {}, create: {}, update: {}, message: null, badReq: null };
    case CLEAR_LEDGER_STATES: return {};
    default: return state;
  }
};
export default ledgerReducer;